import { Sizes } from '@/common/types';
import { Modal } from '@base-app';
import { styled } from '@/stitches.config';
import { ReactComponent as Copy } from '@/assets/icons/copy.svg';
import { useCopyToClipboard } from '@/common/hooks/useCopyToClipboard';

const ContentContainer = styled('div', {
  display: 'flex',
  padding: '$8',
  gap: '$4',
  justifyContent: 'center',
  alignItems: 'center',
});

const TextContainer = styled('div', {
  display: 'flex',
  gap: '$4',
  alignItems: 'center',
  width: '95%',
  overflowWrap: 'anywhere',
});

const Text = styled('span', {
  fontSize: '$xl',
  fontWeight: '$bold',
  color: '$darkGrey100',
  textAlign: 'center',
});

const IconContainer = styled('div', {
  cursor: 'pointer',
  flexBasis: '5%',
});

const GroupIcon = styled(Copy, {});

interface UrlCampaignModalProps {
  show: boolean;
  onClose: () => void;
  modalTitle: string;
  campaignUrl: string;
}

export const UrlCampaignModal = ({ show, onClose, modalTitle, campaignUrl }: UrlCampaignModalProps): JSX.Element => {
  const { copy } = useCopyToClipboard();

  const copyToClipboard = async (): Promise<void> => {
    await copy(campaignUrl);
  };

  return (
    <Modal show={show} title={modalTitle} onClose={onClose} size={Sizes.LARGE} isLocked={false}>
      <ContentContainer>
        <TextContainer>
          <Text>{campaignUrl}</Text>
        </TextContainer>
        <IconContainer onClick={copyToClipboard}>
          <GroupIcon />
        </IconContainer>
      </ContentContainer>
    </Modal>
  );
};
